import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_BRANCH_TREASURY_OPENINGS = '[TREASURY] GET_BRANCH_TREASURY_OPENINGS'
export const GET_BRANCH_TREASURY_CLOSINGS = '[TREASURY] GET_BRANCH_TREASURY_CLOSINGS'
export const SAVE_TREASURY_OPENING = '[TREASURY] SAVE_TREASURY_OPENING'
export const VOID_TREASURY_OPENING = '[TREASURY] VOID_TREASURY_OPENING'
export const CLOSE_TREASURY_OPENING = '[TREASURY] CLOSE_TREASURY_OPENING'
export const UNDO_TREASURY_CLOSING = '[TREASURY] UNDO_TREASURY_CLOSING'

export function getBranchTreasuryOpeningsAction() {
  const request = api.get(`/treasury/branch-openings`)
  return (dispatch) => {
    dispatch({ type: GET_BRANCH_TREASURY_OPENINGS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_BRANCH_TREASURY_OPENINGS, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_BRANCH_TREASURY_OPENINGS, error)
    }).finally(() => {
      dispatch({ type: GET_BRANCH_TREASURY_OPENINGS, payload: { loading: false } })
    })
  }
}

export function getBranchTreasuryClosingsAction(filters = { startDate: '', endDate: '', pageSize: 5 }) {
  const request = api.get(`/treasury/branch-closings`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_BRANCH_TREASURY_CLOSINGS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_BRANCH_TREASURY_CLOSINGS, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_BRANCH_TREASURY_CLOSINGS, error)
    }).finally(() => {
      dispatch({ type: GET_BRANCH_TREASURY_CLOSINGS, payload: { loading: false } })
    })
  }
}

export function saveTreasuryOpeningAction(data) {
  const request = api.post(`/treasury/save-opening`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_TREASURY_OPENING, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_TREASURY_OPENING, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_TREASURY_OPENING, error)
    }).finally(() => {
      dispatch({ type: SAVE_TREASURY_OPENING, payload: { saving: false } })
    })
  }
}

export function voidTreasuryOpeningAction(treasuryId) {
  const request = api.delete(`/treasury/void-opening/${treasuryId}`)
  return (dispatch) => {
    dispatch({ type: VOID_TREASURY_OPENING, payload: { voiding_id: treasuryId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: VOID_TREASURY_OPENING, payload: { voided_id: treasuryId } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(VOID_TREASURY_OPENING, error)
    }).finally(() => {
      dispatch({ type: VOID_TREASURY_OPENING, payload: { voiding_id: treasuryId } })
    })
  }
}

export function closeTreasuryOpeningAction(treasuryId, data) {
  const request = api.put(`/treasury/close-opening/${treasuryId}`, data)
  return (dispatch) => {
    dispatch({ type: CLOSE_TREASURY_OPENING, payload: { closing_id: treasuryId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CLOSE_TREASURY_OPENING, payload: { closed_id: treasuryId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(CLOSE_TREASURY_OPENING, error)
    }).finally(() => {
      dispatch({ type: CLOSE_TREASURY_OPENING, payload: { closing_id: treasuryId } })
    })
  }
}

export function undoTreasuryClosingAction(treasuryId) {
  const request = api.put(`/treasury/undo-closing/${treasuryId}`)
  return (dispatch) => {
    dispatch({ type: UNDO_TREASURY_CLOSING, payload: { undoing_id: treasuryId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: UNDO_TREASURY_CLOSING, payload: { undone_id: treasuryId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(UNDO_TREASURY_CLOSING, error)
    }).finally(() => {
      dispatch({ type: UNDO_TREASURY_CLOSING, payload: { undoing_id: treasuryId } })
    })
  }
}